var $7a5c25747e33eb90$exports = {};
$7a5c25747e33eb90$exports = {
    "collapse": `Strni`,
    "expand": `Raz\u{161}iri`
};


export {$7a5c25747e33eb90$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
